import LoadingKeys from '@/constants/core/LoadingKeys'
import { VuexResponse } from '@/helpers/vuex-action-builder'
import FormSubmissionWithSchemaVM from '@/models/forms/formSubmissionWithSchemaVM'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  getters: {
    isLoadingFormSubmission: (state, getters, rootState, rootGetters) =>
      rootGetters.isLoadingByKey(LoadingKeys.forms.loadingFormSubmission),
    isLoadingFormFile: (state, getters, rootState, rootGetters) => (fileId) =>
      rootGetters.isLoadingByKey(fileId),
  },
  mutations: {
    CLEAR_STORE(state) {
      // Resets store to default state
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    async loadFormSubmission({ commit, dispatch }, passkey) {
      return await new VuexResponse(commit, dispatch)
        .request(() =>
          this.$api.forms.getFormSubmissionAndSchemaByPasskey(passkey)
        )
        .withLoadingByKey(LoadingKeys.forms.loadingFormSubmission)
        .transform((data) => new FormSubmissionWithSchemaVM(data))
        .go()
    },
    async downloadFile({ commit, dispatch }, { passkey, fileId }) {
      return await new VuexResponse(commit, dispatch)
        .request(() => this.$api.forms.downloadFile(passkey, fileId))
        .withLoadingByKey(fileId)
        .withContentDisposition()
        .go()
    },
    async generatePdf({ commit, dispatch }, passkey) {
      return await new VuexResponse(commit, dispatch)
        .request(() => this.$api.forms.generatePdf(passkey))
        .withContentDisposition()
        .go()
    },
    async downloadStampedPdf({ commit, dispatch }, passkey) {
      return await new VuexResponse(commit, dispatch)
        .request(() => this.$api.forms.downloadStampedPdf(passkey))
        .withContentDisposition()
        .go()
    },
    async getFormLatestVersion({ commit, dispatch }, formTemplateId) {
      return await new VuexResponse(commit, dispatch)
        .request(() =>
          this.$api.formTemplates.getFormLatestVersion(formTemplateId)
        )
        .withLoadingByKey(LoadingKeys.forms.loadingFormSubmission) // For displaying skeleton when previewing template
        .go()
    },
    async createFormSubmission(
      { commit, dispatch },
      { formId, formVersionNo, values }
    ) {
      return await new VuexResponse(commit, dispatch)
        .request(() =>
          this.$api.forms.createFormSubmission(formId, formVersionNo, values)
        )
        .withFailureToast(this.$i18n.t('forms.alerts.failCreateFormSubmission'))
        .go()
    },
    async deleteFormSubmission({ commit, dispatch }, passkey) {
      return await new VuexResponse(commit, dispatch)
        .request(() => this.$api.forms.deleteFormSubmission(passkey))
        .withFailureToast(this.$i18n.t('forms.alerts.failDeleteFormSubmission'))
        .go()
    },
    /**
     * Resets store to default state.
     */
    clear({ commit }) {
      commit('CLEAR_STORE')
    },
  },
}
